import { CircleCheck, Info, TriangleAlert } from 'lucide-react';
import PropTypes from 'prop-types';
import React from 'react';

import styles from './Alert.module.scss';

const VARIANT_ICONS = {
  default: TriangleAlert,
  warning: TriangleAlert,
  destructive: TriangleAlert,
  info: Info,
  success: CircleCheck,
};

const Alert = ({
  variant = 'default',
  title,
  children,
  actions,
  icon,
  role,
  flush = false,
  inlineActions = false,
  className = '',
}) => {
  const Icon = icon ?? VARIANT_ICONS[variant];

  return (
    <div
      role={role ?? (variant === 'destructive' ? 'alert' : 'status')}
      className={`${styles.alert} ${styles[variant]} ${flush ? styles.flush : ''} ${className}`.trim()}
    >
      <Icon size={15} className={styles.icon} aria-hidden="true" />
      {inlineActions ? (
        <div className={styles.inlineRow}>
          <div className={styles.body}>
            <div className={styles.title}>{title}</div>
            {children && <div className={styles.description}>{children}</div>}
          </div>
          {actions && <div className={styles.inlineActions}>{actions}</div>}
        </div>
      ) : (
        <div className={styles.body}>
          <div className={styles.title}>{title}</div>
          {children && <div className={styles.description}>{children}</div>}
          {actions && <div className={styles.actions}>{actions}</div>}
        </div>
      )}
    </div>
  );
};

Alert.propTypes = {
  variant: PropTypes.oneOf(['default', 'warning', 'destructive', 'info', 'success']),
  title: PropTypes.node.isRequired,
  children: PropTypes.node,
  actions: PropTypes.node,
  icon: PropTypes.elementType,
  role: PropTypes.string,
  flush: PropTypes.bool,
  inlineActions: PropTypes.bool,
  className: PropTypes.string,
};

export default Alert;
